import { useMemo, useState } from "react";
import { Btn, Dot } from "../ui";
import { resetPassword } from "../auth-client";
import { LegacyMark } from "../LegacyMark";

function tokenFromLocation(): { token: string | null; error: string | null } {
  const params = new URLSearchParams(window.location.search);
  return { token: params.get("token"), error: params.get("error") };
}

function italianResetError(error: string | null): string | null {
  if (!error) return null;
  if (error.toUpperCase() === "INVALID_TOKEN") {
    return "Link non valido o scaduto. Richiedi un nuovo reset della password.";
  }
  return error;
}

export function ResetPassword({ onBackToLogin }: { onBackToLogin: () => void }) {
  const initial = useMemo(() => tokenFromLocation(), []);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState<string | null>(() => italianResetError(initial.error));
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const token = initial.token;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (!token) {
      setErr("Link non valido o scaduto. Richiedi un nuovo reset della password.");
      return;
    }
    if (password !== confirm) {
      setErr("Le password non coincidono");
      return;
    }
    setBusy(true);
    try {
      const res = await resetPassword({ newPassword: password, token });
      if (res.error) {
        setErr(res.error.message ?? "Impossibile aggiornare la password");
        return;
      }
      setDone(true);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Errore");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-brand">
          <LegacyMark className="login-mark" />
          <span className="brand-wordmark">Legacy</span>
        </div>
        <h1 className="login-title">Nuova password</h1>
        <div className="login-sub">
          {done
            ? "Password aggiornata. Ora puoi accedere con le nuove credenziali."
            : "Scegli una nuova password per il tuo account."}
        </div>

        {done ? (
          <Btn variant="primary" block onClick={onBackToLogin}>
            Vai all'accesso
          </Btn>
        ) : (
          <form onSubmit={submit} className="login-form">
            <div className="field">
              <label className="label" htmlFor="reset-password">Nuova password</label>
              <input
                id="reset-password"
                className="input"
                type="password"
                required
                minLength={8}
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="min. 8 caratteri"
                disabled={!token}
              />
            </div>
            <div className="field">
              <label className="label" htmlFor="reset-password-confirm">Conferma password</label>
              <input
                id="reset-password-confirm"
                className="input"
                type="password"
                required
                minLength={8}
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="ripeti la password"
                disabled={!token}
              />
            </div>

            {err && (
              <div className="login-err" role="alert">
                <Dot kind="danger" />
                <span>{err}</span>
              </div>
            )}

            <Btn variant="primary" block disabled={busy || !token}>
              {busy ? "…" : "Salva password"}
            </Btn>
          </form>
        )}

        <div className="login-switch">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              onBackToLogin();
            }}
          >
            Torna all'accesso
          </a>
        </div>
      </div>
    </div>
  );
}
